module.exports = function getResource(label) {
    const resources = {
        signInText: 'Sign In'
    };

    return resources[label];
};
